export const MAX_FILES_LENGTH = 20;

export const DOCUMENT_VERSION_PATTERN = /^\d*\.?\d{0,2}$/;

export const perPageFilterOptions = 20;
